// DS: P20
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
import DollarSignIcon from '@wix/da-ds/pkg/Icons/16x16/DollarSign';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import s from './FolderRibbon.scss';
const FolderRibbon = ({ premiumFolderData , className  })=>{
    const { t  } = useTranslation();
    const { isPremium , isPaidFolder , isWatchToAccess  } = normalizePremiumFolderData(premiumFolderData);
    if (!isPremium) {
        return null;
    }
    let labelTransKey;
    if (isPaidFolder) {
        labelTransKey = 'folderCard.badge.premium';
    }
    if (isWatchToAccess) {
        labelTransKey = 'folderCard.badge.watchers';
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isPaidFolder && s['premium'], isWatchToAccess && s['watchers'], className)
    }, isPaidFolder && /*#__PURE__*/ React.createElement(DollarSignIcon, {
        className: s['icon']
    }), isWatchToAccess && /*#__PURE__*/ React.createElement(FollowingWatchIcon, {
        className: s['icon']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['title']
    }, t(labelTransKey)));
};
FolderRibbon.displayName = 'FolderRibbon';
export default FolderRibbon;
